import { forwardRef } from 'react';
import { cx } from '@eti/styles';
import { Card } from '@etg/wings';
import { analytics } from '@eti/utils';
import { bindCoreComponents, renderCoreComponents, sortCoreComponents } from '../utils/product-layout-utils';
import ProductCardContextProvider from '../context/ProductCardContext';
import { productWrapperStyles } from './styles';
import { jsx as _jsx } from "react/jsx-runtime";
const createProductLayout = ({
  coreComponents,
  defaultGrid,
  mouseFlowTag
}) => {
  const Layout = /*#__PURE__*/forwardRef(({
    children,
    customGrid,
    productData,
    className,
    coreComponentsRenderConfig
  }, ref) => {
    analytics.useLogMouseFlowTagEffect(mouseFlowTag !== null && mouseFlowTag !== void 0 ? mouseFlowTag : '', Boolean(mouseFlowTag));
    const {
      productName,
      isHighlighted,
      productId
    } = productData;
    const sortedCoreComponents = sortCoreComponents(Layout, coreComponentsRenderConfig);
    return /*#__PURE__*/_jsx(ProductCardContextProvider, {
      productData: productData,
      children: /*#__PURE__*/_jsx(Card, {
        className: cx(productWrapperStyles(isHighlighted), className, customGrid !== null && customGrid !== void 0 ? customGrid : defaultGrid),
        "data-offer-rate": productId,
        "data-testid": `${productName}-container`,
        ref: ref,
        children: renderCoreComponents(sortedCoreComponents, children)
      })
    });
  });
  return bindCoreComponents(Layout, coreComponents);
};
export default createProductLayout;
//# sourceMappingURL=createProductLayout.js.map